// import {
//   HttpErrorResponse,
//   HttpEvent,
//   HttpHandler,
//   HttpInterceptor,
//   HttpRequest,
// } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { Observable, catchError, throwError } from 'rxjs';
// import { environment } from '../../../environments/environment';
// import { AuthService } from './auth.service';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   constructor(private auth: AuthService) {}

//   intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
//     const token = this.auth.getAccessToken();
//     const isApiRequest = req.url.startsWith(environment.apiBaseUrl);

//     console.log('AuthInterceptor - Request URL:', req.url);
//     console.log('AuthInterceptor - Is API Request:', isApiRequest);
//     console.log('AuthInterceptor - Token exists:', !!token);
//     console.log('AuthInterceptor - Token preview:', token ? `${token.substring(0, 20)}...` : 'null');

//     const authReq = token && isApiRequest
//       ? req.clone({
//           setHeaders: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//       : req;

//     if (token && isApiRequest) {
//       console.log('AuthInterceptor - Added Authorization header');
//     } else {
//       console.log('AuthInterceptor - No token added. Token:', !!token, 'IsAPI:', isApiRequest);
//     }

//     console.log('AuthInterceptor - Final headers:', authReq.headers.keys());

//     return next.handle(authReq).pipe(
//       catchError((err: unknown) => {
//         console.error('AuthInterceptor - Request failed:', err);
//         if (err instanceof HttpErrorResponse) {
//           console.error('AuthInterceptor - HTTP Error:', {
//             status: err.status,
//             statusText: err.statusText,
//             url: err.url
//           });
//           if (err.status === 401) {
//             console.log('AuthInterceptor - 401 error, logging out');
//             this.auth.logout();
//           }
//         }
//         return throwError(() => err);
//       }),
//     );
//   }
// }

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {
  Injectable
} from '@angular/core';

import {
  catchError,
  Observable,
  switchMap,
  throwError
} from 'rxjs';

import { environment } from
  '../../../environments/environment';

import { AuthService } from
  './auth.service';
import { AUTH_RETRIED, SKIP_AUTH } from '../constants/auth-context';


@Injectable()
export class AuthInterceptor
  implements HttpInterceptor {

  constructor(
    private auth: AuthService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.context.get(SKIP_AUTH) ||
      !this.isApiRequest(request.url)
    ) {
      return next.handle(request);
    }

    return this.auth
      .ensureValidAccessToken()
      .pipe(
        switchMap(token =>
          this.send(
            request,
            next,
            token
          )
        )
      );
  }

  private send(
    request: HttpRequest<unknown>,
    next: HttpHandler,
    token: string
  ): Observable<HttpEvent<unknown>> {
    const authenticatedRequest =
      this.withToken(
        request,
        token
      );

    return next
      .handle(authenticatedRequest)
      .pipe(
        catchError(error => {
          if (
            !(error instanceof
              HttpErrorResponse) ||
            !this.isAuthExpiryStatus(
              error.status
            ) ||
            request.context.get(
              AUTH_RETRIED
            )
          ) {
            return throwError(
              () => error
            );
          }

          return this.auth
            .refreshAccessToken()
            .pipe(
              switchMap(newToken => {
                const retryRequest =
                  request.clone({
                    context:
                      request.context.set(
                        AUTH_RETRIED,
                        true
                      ),

                    setHeaders: {
                      Authorization:
                        `Bearer ${newToken}`
                    }
                  });

                return next.handle(
                  retryRequest
                );
              }),

              catchError(refreshError => {
                this.auth.logout();

                return throwError(
                  () => refreshError
                );
              })
            );
        })
      );
  }

  /*
   * Some services (auth-service via Spring Security's default
   * entry point, job-service via its own manual authorization
   * gateway) answer an expired/invalid token with 403 instead of
   * the more precise 401. Treating both the same way lets an
   * expired access token recover with a silent refresh instead of
   * surfacing as a dead end to the user.
   */
  private isAuthExpiryStatus(
    status: number
  ): boolean {
    return status === 401 || status === 403;
  }

  private withToken(
    request: HttpRequest<unknown>,
    token: string
  ): HttpRequest<unknown> {
    return request.clone({
      setHeaders: {
        Authorization:
          `Bearer ${token}`
      }
    });
  }

  private isApiRequest(
    url: string
  ): boolean {
    const apiBase =
      String(
        environment.apiBaseUrl || ''
      ).replace(/\/$/, '');

    return (
      url.startsWith('/api/') ||
      Boolean(
        apiBase &&
        url.startsWith(apiBase)
      )
    );
  }
}